import PageMeta from "../../components/common/PageMeta";
import ImgLayout from "../../pages/ImgPages/ImgPageLayout";
import OnboardingForm from "../../components/onboarding/OnboardingForm";

export default function Onboarding() {
    return (
        <>
            <PageMeta
                title="Onboarding - Sellyo"
                description="Vamos trabalhar juntos"
            />
            <ImgLayout>
                <OnboardingForm />
            </ImgLayout>
        </>
    );
}
